// Explicit CSS entry for the cards primitive set.
// Consumers import this exactly once from the app entry (or a route that
// first renders a card) to activate --tbc-* tokens and primitive classes.
//
// Kept out of ./index.ts so the barrel has no CSS side-effect — this lets
// Next.js tree-shake the barrel for consumers that only need type exports
// (see bundle-barrel-imports in .claude/skills/vercel-react-best-practices).
import './tokens.css';
import './primitives.css';
import './variants/EndOfFeed/EndOfFeed.css';
